import { useQuery } from 'react-query';

import { getCardTransactionDetails } from 'modules/cards/api/getCardTransactionDetails';

export const useGetCardTransactionDetails = ({
  companyId,
  transactionId,
}: {
  companyId: string;
  transactionId: string;
}) => {
  return useQuery(
    ['cardTransactionDetails', companyId, transactionId],
    () => getCardTransactionDetails({ companyId, transactionId }),
    {
      enabled: Boolean(companyId) && Boolean(transactionId),
      refetchOnWindowFocus: false,
    },
  );
};
